import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { asidebuyerUpcomingData } from "../../../../../redux/action/buyer";
import {
  convertTo12HourFormat,
  handleDateSetUp,
  NoItemsLeftInTable,
} from "../../../../../helpers/helpers";
import UpcommingLoader from "../../../../loader/UpcommingLoader";
import { useNavigate } from "react-router-dom";

function RightAside() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isDastop = useMediaQuery({ query: "(max-width: 1700px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1300px)" });
  const isSmallLaptop = useMediaQuery({ query: "(max-width: 1020px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 880px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 550px)" });
  const [hoveredItem, setHoveredItem] = useState(null);
  const { asideBuyerUpcoming, loadings } = useSelector(
    (pre) => pre.buyerUpcoming
  );
  const [upCommingAuction, setUpCommingAuction] = useState([]);

  const handleMouseEnter = (index, e) => {
    e.preventDefault();
    setHoveredItem(index);
  };
  const [numLiveData, setNumLiveData] = useState(4);

  useEffect(() => {
    dispatch(asidebuyerUpcomingData());
  }, [dispatch]);

  useEffect(() => {
    setUpCommingAuction(asideBuyerUpcoming);
  }, [asideBuyerUpcoming]);

  //   handle the view live pages funtionality=============>>>>>>>>>>>>>>>
  const handleViewButton = () => {
    setNumLiveData(upCommingAuction?.length);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  if (loadings) {
    return <UpcommingLoader />;
  }

  return (
    <div
      className={`cover white ${isTablet ? "" : "horizontal-scroll-bar custom-scrollbar"
        }`}
      style={{
        width: isTablet
          ? "100%"
          : isSmallLaptop
            ? "34%"
            : isLaptop
              ? "29%"
              : isDastop
                ? "23%"
                : "380px",
        position: !isTablet && "fixed",
        right: "0px",
        padding: "15px",
        paddingBottom: !isTablet && "5rem",
        flexGrow: "",
      }}
    >
      <div className="valign-wrapper space-between mb-1 flex-wrap">
        <h6 className="margin-0px">
          Upcoming Auctions for you
        </h6>
        {/* <span
          className="small-text grey lighten-3 "
          style={{
            padding: "5px 7px",
            borderRadius: "18px",
            fontWeight: "300",
            marginTop: "5px",
          }}
        >
          Paid EMDs
        </span> */}
      </div>
      <div
        className={`${isTablet && "gap-1"}`}
        style={{
          display: "grid",
          gridTemplateColumns: isMobile
            ? "repeat(1,1fr)"
            : isTablet
              ? "repeat(2,1fr)"
              : "",
        }}
      >
        {(isTablet
          ? upCommingAuction?.slice(0, numLiveData)
          : upCommingAuction
        )?.map((items, index) => (
          <>
            {hoveredItem === index ? (
              <div
                className="cover valign-wrapper justify-center mb-1 pointer"
                style={{ height: "205px", backgroundColor: "#f1ebfa" }}
                onMouseLeave={handleMouseLeave}
                key={index}
                onClick={() => {
                  if (items?.auctionType === "reverseAuctionProduct") {
                    navigate(`/reverse-product-auction/auction-details/${items?._id}`);
                  } else if (items?.auctionType === "reverseAuctionService") {
                    navigate(`/reverse-service-auction/auction-details/${items?._id}`);
                  } else {
                    navigate(`/forward-auction/auction-details/${items?._id}`);
                  }
                }}
              >
                <h6 className="font-cercular-bold cercle-purple-text">View Details</h6>
              </div>
            ) : (
              <div
                key={index}
                className={`cover ${!isTablet && "mb-1"} flex column p-1 hoverStyle`}
                style={{ gap: "0.8rem" }}
                onMouseEnter={(e) => handleMouseEnter(index, e)}
                onMouseLeave={handleMouseLeave}
              >
                <div className="valign-wrapper" style={{ gap: "18px" }}>
                  <span
                    className="circle valign-wrapper justify-center pointer"
                    style={{
                      minWidth: "60px",
                      height: "60px",
                    }}
                  >
                    <img
                      src="/images/auctionLogoNew.png"
                      alt="plus"
                      style={{ width: "60px" }}
                    />
                  </span>
                  <span>
                    <h6
                      className={`font-circular-bold black-text font-14px`}
                      style={{ fontWeight: 700 }}
                    >
                      Auction ID: <span>{items?.auctionId}</span>
                    </h6>
                    <p
                      className="font-inter-sans-serif NoOfline"
                      style={{
                        WebkitLineClamp: 2,
                        fontSize: "11px",
                        fontWeight: "500",
                        letterSpacing: "0.2px",
                        color: "#70707080",
                      }}
                    >
                      {items?.description}
                    </p>
                  </span>
                </div>
                <p
                  className="black-text font-13px border-radius-12 NoOfline"
                  style={{
                    backgroundColor: "rgba(224, 233, 255, 0.3)",
                    padding: "4px 10px",
                    width: "96%",
                    WebkitLineClamp: 1,
                  }}
                >
                  {items?.location?.address}
                </p>
                <div className="flex" style={{ gap: "24px" }}>
                  <span
                    className="flex justify-center column border-radius-12 "
                    style={{
                      width: "43%",
                      padding: "10px 15px",
                      backgroundColor: "#ACACAC1A",
                    }}
                  >
                    <p className="black-text font-14px font-circular-bold">
                      Time:
                    </p>
                    <p className="grey-text" style={{ fontSize: "13px" }}>
                      {convertTo12HourFormat(
                        items?.auctionSchedule?.startingTime
                      )}
                    </p>
                  </span>
                  <span
                    className="flex justify-center column border-radius-12"
                    style={{
                      width: "50%",
                      padding: "10px 15px",
                      backgroundColor: "#ACACAC1A",
                    }}
                  >
                    <p className="black-text font-14px font-circular-bold">
                      Date
                    </p>
                    <p className="grey-text" style={{ fontSize: "13px" }}>
                      {handleDateSetUp(items?.auctionSchedule?.startDate)}
                    </p>
                  </span>
                </div>
              </div>
            )}
          </>
        ))}
      </div>
      {isTablet && (
        <>
          {numLiveData === 4 && upCommingAuction?.length > 4 ? (
            <div className="flex justify-center mb-1 mt-1">
              <button
                className="bold font-14px white-text cercle-purple border-radius-12"
                style={{ padding: "7px 10px" }}
                onClick={handleViewButton}
              >
                View More
              </button>
            </div>
          ) : (
            upCommingAuction?.length !== 0 && <div className="flex justify-center  mt-1">
              <button
                className="bold font-14px white-text cercle-purple border-radius-12 mb-1"
                style={{ padding: "7px 10px" }}
                onClick={() => {
                  setNumLiveData(4);
                }}
              >
                View Less
              </button>
            </div>
          )}
        </>
      )}
      {upCommingAuction?.length === 0 && <div className="cover mb-1"><NoItemsLeftInTable /></div>}
    </div>
  );
}

export default RightAside;
